import React from "react";
import {Row} from "react-bootstrap";
import {InputPassword} from "../../../genericComponents";

function CustomerSurvey13() {
  return (
    <Row>
      <InputPassword
        colProps={{ xs: 12 }}
        label="Senha do INSS"
        name="inssPassword"
        inputMaskProps={{
          placeholder: "Informe a sua senha do INSS",
        }}
        maxLength={255}
      />
    </Row>
  );
}

export default React.memo(CustomerSurvey13);
